import { Box } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { getQueryParams, stringifyObj } from 'constants/helper';

import { BreadCrumb, BreadcrumbItem, BreadcrumbLink } from 'uiToolkitV1/BreadCrumb';

export const BreadCrumbComponent = ({
  location,
  panelStack = [],
  currentPanelBreadcrumbText = 'Initiative',
  onBreadCrumbLinkClicked = () => {},
}) => {
  const { objectivesName, keyResultsName } = useOrganisationSettings();
  const otherQueryParams = getQueryParams(location.search);
  return (
    <BreadCrumb style={{ lineHeight: '1' }}>
      {panelStack.map(({ drawerType, params }, index) => {
        const okrQueryParamObj = {
          objectivePId: null,
          ids: null,
          showTaskDetails: null,
          type: null,
          empId: null,
        };

        if (drawerType === 'OBJECTIVE') {
          okrQueryParamObj.objectivePId = params?.objectivePId;
        } else if (drawerType === 'COMPETENCY') {
          okrQueryParamObj.empId = otherQueryParams?.empId;
          okrQueryParamObj.isCompetencyPanelOpen = 'true';
        } else {
          okrQueryParamObj.ids = params?.id;
          okrQueryParamObj.showTaskDetails = true;
          okrQueryParamObj.type = params?.type;
        }

        const panelStackArrayTillIndex = panelStack.slice(0, index);

        const searchString = stringifyObj({
          ...otherQueryParams,
          ...okrQueryParamObj,
          panelStack:
            Array.isArray(panelStackArrayTillIndex) && panelStackArrayTillIndex.length > 0
              ? JSON.stringify(panelStackArrayTillIndex)
              : null,
        });

        const route = `${location.pathname}?${searchString}`;

        return (
          // eslint-disable-next-line react/no-array-index-key
          <BreadcrumbItem key={index}>
            <BreadcrumbLink to={route} onClick={onBreadCrumbLinkClicked}>
              <Box flexGrow={0} flexShrink={0}>
                {drawerType === 'OBJECTIVE' ? objectivesName : null}
                {drawerType === 'GOAL' ? keyResultsName : null}
                {drawerType === 'TASK' ? 'Initiative' : null}
                {drawerType === 'OTHER' ? params?.label : null}
                {drawerType === 'COMPETENCY' ? 'Competency' : null}
              </Box>
            </BreadcrumbLink>
          </BreadcrumbItem>
        );
      })}
      <BreadcrumbItem isCurrentPage>
        <BreadcrumbLink as="span">{currentPanelBreadcrumbText}</BreadcrumbLink>
      </BreadcrumbItem>
    </BreadCrumb>
  );
};
